import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { isScullyRunning } from '@scullyio/ng-lib';

import { environment } from '../../../environments/environment';

declare const window: any;

@Injectable()
export class LivechatService {
  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}

  init(): void {
    if (!isScullyRunning()) {
      this.loadScript();
      this.listenRoutes();
    }
  }

  private listenRoutes(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => this.setPath(window.location), 1000);
      }
    });
  }

  private loadScript(): void {
    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.src = `//js.hs-scripts.com/${environment.livechatId}.js`;
    script.async = true;
    script.defer = true;
    this.document.body.append(script);
  }

  private reloadOrRefresh(): void {
    const status = window.HubSpotConversations?.widget.status();
    if (status?.loaded) {
      window.HubSpotConversations?.widget.refresh();
    } else {
      window.HubSpotConversations?.widget.load();
    }
  }

  private setPath(path: string): void {
    window._hsq?.push(['setPath', path]);
    this.reloadOrRefresh();
  }
}
